import React, {Component} from 'react';
import BaseLayout from './../../templates/base';
import logo from './../../assets/images/inmujeres_gray.svg';
import escudo from './../../assets/images/escudo-01.svg';
//import {NavLink} from 'react-router-dom';

class Welcome extends Component {
	render() {
		const {profile} = this.props.session.user;
		return (
			<div className="columns is-multiline">
				<div className="column is-10 is-offset-1">
					<div className="level">
						<div className="level-item">
							<img src={logo} alt="INMUJERES" style={{width: 'auto', height: '120px'}}/>
						</div>
						<div className="level-itemgit ">
							<img src={escudo} alt="INMUJERES" style={{width: 'auto', height: '120px'}}/>
						</div>
					</div>
				</div>
				<div className="column is-10 is-offset-1">
					<br/><br/>
					<div className="content">
						<h1>{profile.sex === 'M' ? 'Bienvenida' : 'Bienvenido'} {profile.title ? `${profile.title}. ${profile.name}` : profile.name},</h1>
						<p>El <strong>Instituto Nacional de las Mujeres</strong> y en especial la <strong>Dirección de la Política Nacional de Igualdad en el Ámbito Político y Social</strong> responsable
							de la operación del Programa Proequidad, pone a disposición de las Instancias de las Mujeres en las Entidades Federativas (IMEF), la Plataforma e-proequidad para el registro de la
							información y documentación solicitada en las etapas del proceso y recibir notificaciones refrentes al Programa.</p>
						<p>La cobertura del Proequidad es nacional; las 32 entidades federativas, los municipios y las alcaldías de la Ciudad de México.</p>

						<p>La invitamos a consultar la sección de "Ayuda” donde encontrará diferentes documentos normativos, de apoyo, así como el calendario con las fechas más relevantes de las
							etapas operativas del Programa.</p>
					</div>
				</div>
			</div>
		);
	}
}

export default BaseLayout(Welcome);


// WEBPACK FOOTER //
// ./src/layouts/welcome/index.jsx